// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__EOKyO"};